import type { DayKey } from '../../constants/weekDayConstants';

// Re-exported so existing schedule-form consumers keep one import site; the
// canonical definitions moved to constants/ for reuse outside this form
// (e.g. staffCapacityService).
export type { DayKey } from '../../constants/weekDayConstants';
export { DAY_LABEL_KEYS, DAY_ORDER } from '../../constants/weekDayConstants';

export interface DaySchedule {
  enabled: boolean;
  startTime: string; // 'HH:mm'
  endTime: string; // 'HH:mm'
}

export type WeekScheduleForm = Record<DayKey, DaySchedule>;

export type WeekParity = 'evenWeeks' | 'oddWeeks';

export interface AvailabilityForm {
  isAlternating: boolean;
  evenWeeks: WeekScheduleForm;
  oddWeeks: WeekScheduleForm;
}

export const DEFAULT_START_TIME = '08:00';
export const DEFAULT_END_TIME = '16:00';
export const DEFAULT_WORKING_DAYS: readonly DayKey[] = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY'
] as const;
